<template>
  <div class="adv">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="img">
        <img src="@/assets/imgs/shouye.jpg" alt="" class="image" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 路由导航 -->
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">

          <el-breadcrumb-item :to="{ path: '/newsInfo' }"
            >新闻资讯</el-breadcrumb-item
          >
          <el-breadcrumb-item>馆内动态</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 中部内容 -->
      <div class="teach-content">
        <!-- 版心内容 -->
        <div class="teach-box">
          <!-- 左侧内容 -->
          <div class="teach-left">
            <p class="title">
              {{ List.title }}
              <!-- 全国政协委员卢永琇：加强乡村文化建设 助力乡村振兴战略 -->
            </p>
            <p class="dat">
              发布日期：{{ List.publishTime }} 浏览次数：{{ List.viewCount }}次
            </p>
            <div class="left-pub" v-html="List.content">
              <!-- 沪上美术馆首次集中亮相2020年市民文化节暨“3.28文化服务日”，
            为广大市民和游客带来一道精彩纷呈的艺术大餐。 春节至今，沪上美术馆依托微信、官网、App、小程序等平台，<br>
            陆续推出了公共教育活动300余项，为观众提供了主题多元、安全便捷的在线文化服务。 本次“云上美术馆计划”充分发挥美术馆传播美育知识方面的作用，
            针对不同年龄层次，遴选出100项丰富多彩的在线讲座、导览、工作坊等公共教育活动，让市民和游客近距离地感受文化，<br>
            共享艺术成果。 | 中华艺术宫（上海美术馆）| 一座优秀的美术馆，既是艺术殿堂，也是文化地标。中华艺术宫（上海美术馆）见证了上海这座城市的发展，
            也记录和传承着这里独特的文化精神。<br> 海上书法名家<br> 为发挥“上海美术大课堂”的美育职能，推进普及教育的深度广度，<br>
            中华艺术宫策划推出“海上书法名家”线上系列讲座。“海上书法名家”线上系列讲座，邀请6位沪上书家开堂授课，其内容不仅注重书法艺术的传承与创新，
            更聚焦海派书法的文化底蕴，使观众愈发理解书法美在何处。<br>目前已推出一系列书法艺术家的高品质艺术讲座，实现“宅”在家听讲座体验不一样的美育课程。
             <br>海派书画名家<br> 《海派书画名家》系列线上讲座共八期，从大家熟知的艺术大家谈起，诠释"海派文化"的形成发展以及它的前世今生的故事。<br>
             著名艺术评论家、书画家、西泠印社社员王琪森先生每一期将推出一个主题、一位名家，并邀请海派名家后人做客讲座现场，如：吴湖帆先生后人吴元京、
             刘海粟先生之女刘蟾、唐云先生之子唐逸览、程十发先生之子程多多、钱瘦铁先生后人等，共同分享艺术大家的艺术人生。<br>海派书画名家<br> -->
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="teach-right">
            <div class="big-title">新闻资讯</div>
            <div class="ge"></div>
            <!-- <div class="tong chang">通知公告</div>
            <div class="tong">馆内动态</div>
            <div class="tong">媒体报道</div> -->
            <el-menu>
              <sideBar
                :list="rigthBoxData"
                :sidebarTitle="sidebarTitle"
              ></sideBar>
            </el-menu>
            <div class="sma-title">服务指南</div>
            <div class="ge"></div>
            <div class="ope">开馆时间</div>
            <div class="right-pub" v-if="info.length" v-html="info[0].value">
              <!-- 友情提示：上饶美术馆周一闭馆（不含节
              假日）疫情期间实行分时预约参观。<br>
               每日可预约时间段如下：9:00-11:00；
                11:00-14:00；14:00-16:00<br>
                地址：上饶市信州区平江道60号<br>
                电话：022—83883300 -->
            </div>
            <div class="adr-tit">美术馆地址</div>
            <!-- 地图内容 -->
            <div class="right-img">
              <!-- <baidu-map
                @ready="handler"
                style="height:103px"
                :scroll-wheel-zoom="true"
              ></baidu-map> -->
              <baidu-map
                @ready="mapHandle"
                :scroll-wheel-zoom="true"
                style="width:100%;height:103px"
                :key="map.longitude"
              ></baidu-map>
            </div>
            <!-- 按钮 -->
            <div class="order" @click="click">参展预约</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sideBar from "@/components/sideBar";
export default {
  components: {
    sideBar,
  },
  data() {
    return {
      map: {
        longitude: 1,
        latitude: 1,
        address: "",
      },
      sidebarTitle: "新闻资讯",
      rigthBoxData: [
        {
          name: "通知公告",
          index: "menu1",
          path: "/notice",
          children: [],
        },
        {
          name: "馆内动态",
          index: "menu2",
          path: "/musInfo",
          children: [],
        },
        {
          name: "媒体报道",
          index: "menu3",
          path: "/medInfo",
          children: [],
        },
      ],
      List: [],
      title: "",
      info: {},
    };
  },
  created() {
    this.getServiceGuide();
    this.init();
  },
  methods: {
    click() {
      this.$router.replace("/spectatorService/appointment");
    },
    getServiceGuide() {
      this.$axios({
        method: "get",
        url: "/frontapi/service/information/mapCoordinate",
        data: {},
      }).then((res) => {
        if (res.data.mapCoordinate) {
          var arr = res.data.mapCoordinate.split(",");
          this.map.longitude = parseFloat(arr[0]);
          this.map.latitude = parseFloat(arr[1]);
          this.map.address = res.data.address;
        }
      });
    },
    mapHandle({ BMap, map }) {
      var point = new BMap.Point(this.map.longitude, this.map.latitude);
      map.centerAndZoom(point, 13);
      var icon = new BMap.Icon(
        require("../../assets/imgs/map-position.png"),
        new BMap.Size(74, 84)
      );
      var marker = new BMap.Marker(point, { icon: icon }); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var html = [];
      var opts = {
        width: 250,
        height: 30,
      };

      html.push('<div class="mapTipWindow"> <ul>');
      html.push("<li>" + this.map.address + "</li>");
      html.push("</ul></div>");
      var infowindow = new BMap.InfoWindow(html.join(""), opts);
      marker.addEventListener("click", function() {
        this.openInfoWindow(infowindow);
      });
    },
    init2() {
      let id = this.$route.query.id;
      // 在这里拿到id后调你想渲染的接口数据就可以了
      this.$axios.get(`/frontapi/news/information?id=${this.$route.query.id}`);
    },
    handler({ BMap, map }) {
      var point = new BMap.Point(118.003807, 28.48171);
      map.centerAndZoom(point, 13);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, {
        strokeColor: "Red",
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: "Red",
        fillColor: "#f03",
      });
      map.addOverlay(circle);
    },
    init() {
      const _this = this;
      console.log("sdhkjhdslkjsaiuifksadjoi");
      this.$axios
        .get(`/frontapi/news/information/${this.$route.query.id}`)
        .then(function(res) {
          console.log(res);
          _this.List = res.data.data;
          console.log(_this.List);
          //  const id = Number(_this.$route.query.id);
          //  _this.titleData = _this.list.filter(item=>item.id===id)[0].title;
          //  console.log(_this.titleData)
        });
    },
  },
  mounted() {
    // this.init()
    var that = this;
    this.$axios
      .get(
        this.$axios.defaults.baseURL+"/frontapi/service/information/list?name=开馆时间"
      )
      .then(
        function(res) {
          console.log(res);
          that.info = res.data.rows;
          console.log(12345);
          console.log(that.info);
        },
        function() {
          // console.log("请求失败");
        }
      );
  },
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
  font-size: 18px;
}
img {
  font-size: 18px;
}
.nav >>> .el-breadcrumb__inner.is-link {
  font-weight: 500;
  text-decoration: none;
  color: #606266;
}
.right-img >>> .BMap_cpyCtrl {
  display: none;
}
* {
  margin: 0;
  padding: 0;
}
i {
  font-style: normal;
}
.adv {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
  padding-bottom: 0.833333rem /* 60px -> 0.833333rem */;
}
.banner {
  width: 100%;
  height: auto;
}
.img {
  width: 100%;
  height: 100%;
}
.image {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  padding-top: 60px;
}
.nav {
  font-size: 18px;
  width: 1199px;
  height: 18px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.about >>> .nav {
  cursor: pointer;
}
.about >>> .is-link {
  font-weight: 400;
  color: #606266;
  /* cursor: text; */
}
.nav >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.teach-content {
  height: auto;
  width: 100%;
  /* background: pink; */
}
.teach-box {
  width: 1199px;
  height: auto;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
/* 内容左 */
.teach-left {
  width: 860px;
  height: auto;
  border-radius: 10px;
  background: #fff;
}
.title {
  margin-left: 30px;
  margin-top: 29px;
  font-size: 24px;
  line-height: 1.2;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
}
.dat {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  margin-top: 19px;
  text-align: center;
  margin-bottom: 18px;
}
.left-pub {
  width: 803px;
  font-size: 16px;
  height: auto;
  /* background:pink; */
  margin: 0 auto 30px;
  line-height: 26px;
}

.left-pub >>> img {
  width: 100%;
}

/* 内容右 */
.teach-right {
  width: 309px;
  height: 903px;
  border-radius: 10px;
  background: #fff;
  padding-left: 30px;
  padding-right: 30px;
}
.big-title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-top: 29px;
  margin-bottom: 29px;
}
.ge {
  /* width: 250px; */
  height: 2px;
  background: #222222;
}
.tong {
  height: 56px;
  /* width:250px; */
  /* background: pink; */
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  border-bottom: 1px solid #eeeeee;
  line-height: 56px;
}
.chang {
  color: #b78c0d;
}
.sma-title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-top: 79px;
  margin-bottom: 29px;
}
.ope {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  margin-top: 19px;
}
.right-pub {
  margin-top: 19px;
  /* width: 250px; */
  /* height: 145px; */
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 25px;
}
.adr-tit {
  margin: 20px 0;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
}
.right-img {
  /* width: 250px; */
  height: 103px;
  background: chocolate;
}
.order {
  /* width: 250px; */
  height: 40px;
  border: 1px solid #b78c0d;
  border-radius: 4px;
  background: #fff;
  color: #b78c0d;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
</style>
